var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedinProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_56_716)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 30,
    r: 20,
    fill: "#07031F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_56_716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8762 35.8838V35.8832H39.8794V31.1371C39.8794 28.8152 39.3795 27.0266 36.6651 27.0266C35.3602 27.0266 34.4845 27.7427 34.127 28.4216H34.0893V27.2434H31.5156V35.8832H34.1955V31.6051C34.1955 30.4787 34.4091 29.3895 35.804 29.3895C37.1785 29.3895 37.199 30.6749 37.199 31.6773V35.8838H39.8762Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1484 27.2427H29.8316V35.8825H27.1484V27.2427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4915 22.9412C27.6336 22.9412 26.9375 23.6373 26.9375 24.4952C26.9375 25.3531 27.6336 26.0638 28.4915 26.0638C29.3494 26.0638 30.0455 25.3531 30.0455 24.4952C30.045 23.6373 29.3489 22.9412 28.4915 22.9412V22.9412Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_56_716",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_56_716"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_56_716",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_56_716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.9412,
    height: 12.9412,
    fill: "white",
    transform: "translate(26.9375 22.9412)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinProfile);
export default __webpack_public_path__ + "static/media/linkedin-profile.6c6b623cad8f221e4030be2bdc18a0b1.svg";
export { ForwardRef as ReactComponent };